import { auth } from '../firebase';
import { buildApiUrl } from '../config/env';

const authHeaders = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error('You must be signed in');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${await currentUser.getIdToken()}`,
  };
};

const request = async (path, options = {}) => {
  const response = await fetch(buildApiUrl(path), {
    ...options,
    headers: {
      ...(await authHeaders()),
      ...(options.headers || {}),
    },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = new Error(body.error || `Giving request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const fetchCurrentGivingCycle = () => request('/giving/current');

export const castGivingVote = (nomineeId) =>
  request('/giving/current/vote', {
    method: 'POST',
    body: JSON.stringify({ nomineeId }),
  });

export const listGivingCyclesAdmin = () => request('/admin/giving/cycles');

export const createGivingCycleAdmin = (cycle) =>
  request('/admin/giving/cycles', {
    method: 'POST',
    body: JSON.stringify(cycle),
  });

export const updateGivingCycleAdmin = (id, cycle) =>
  request(`/admin/giving/cycles/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(cycle),
  });

export const setGivingCycleStatusAdmin = (id, status) =>
  request(`/admin/giving/cycles/${encodeURIComponent(id)}/status`, {
    method: 'PUT',
    body: JSON.stringify({ status }),
  });
